import React from 'react';

export interface MetricsGridProps {
  children: React.ReactNode;
  columns?: number; // Number of columns (1-4)
}

export const MetricsGrid: React.FC<MetricsGridProps> = ({ children, columns = 3 }) => {
  const gridClass = `franchise-metrics-grid franchise-metrics-grid-cols-${columns}`;
  
  return <div className={gridClass}>{children}</div>;
};
